export default "__VITE_ASSET__BrA1YzYL__"